export enum NotificationEvents {
  actionRedirectLogout = 'action.redirect.logout',
  messageSuccessExportFile = 'message.success.file',
  messageInfoExportFile = 'message.info.file',
  messageInfoNews = 'message.announcement.news',
  messageFetchMvpsCalculation = 'action.refetch.mvpsCalculation',
  messageFetchInfrastructureCalculation = 'action.refetch.infrastructureCalculation',
  messageFetchTrainFinalIndicators = 'action.refetch.carriageGroupFinalCalculation',
  messageFetchInfrastructureCalculationByBranch = 'action.refetch.infrastructureCalculationByBranch',
  messageFetchMvpsCalculationByBranch = 'action.refetch.mvpsCalculationByBranch',
  messageFetchLocomotiveFinalCalculationsByDirectorates = 'action.refetch.locomotiveFinalCalculationsByDirectorates',
  messageFetchSyncSeatsAvailability = 'action.refetch.syncSeatsAvailability',
  messageErrorSyncSeatsAvailability = 'action.error.syncSeatsAvailability',
  messageFetchReplenishmentCalculation = 'action.refetch.schemasControlReplenishment',
}

export const USER_CLEAR_CACHE_MESSAGE =
  'Завершены работы по обновлению стенда. В связи с этим все предыдущие сессии являются неактуальными и будут автоматически завершены.';
